import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineWineBottleIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" fillRule="evenodd" d="M9 2c0-.5523.4477-1 1-1h3c.5523 0 1 .4477 1 1v4.3944a1 1 0 0 0 .1679.5548l1.3283 1.9922A3.0003 3.0003 0 0 1 16 10.6056V22c0 .5523-.4477 1-1 1H8c-.5523 0-1-.4477-1-1V10.6056a3 3 0 0 1 .5038-1.6642l1.3283-1.9922A1 1 0 0 0 9 6.3944V2Zm5 8.6056V12H9v-1.3944a.9997.9997 0 0 1 .168-.5547l1.3282-1.9924A2.8952 2.8952 0 0 0 10.5342 8h1.9316c.0124.0197.0251.0392.038.0586l1.3283 1.9923a.9997.9997 0 0 1 .1679.5547ZM12 6V3h-1v3h1ZM9 17v-3h5v3H9Zm0 2h5v2H9v-2Z" clipRule="evenodd"/>
  </SvgIcon>
}

export default LineWineBottleIcon
